import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format, parseISO } from "date-fns";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ServiceTemplateScheduleRow } from "../serviceTemplateSchedulesViewConfig";
import { SCHEDULE_DATE_FORMAT } from "../serviceTemplateSchedule.constants";

/**
 * Renders a date derived from the schedule's next on-or-after-today SCHEDULED
 * occurrence (application date, service start/end, or work start/end — see
 * `getNextOccurrenceDatesByScheduleIds`). Dash when none qualifies
 * (paused/expired/all applied/skipped, or only past due shells). Group rows
 * always dash — the value differs per child schedule.
 */
export const ServiceTemplateScheduleNextOccurrenceDateCell = memo(
    ({
        getValue,
        row,
    }: CellContext<
        ViewTableFeatures,
        ServiceTemplateScheduleRow,
        string | null | undefined
    >) => {
        // Group rows aggregate multiple schedules — their next-occurrence
        // dates are not meaningful, so we always render a dash for them.
        if (row.original.rowType === "group") {
            return (
                <ViewTableCell>
                    <span>-</span>
                </ViewTableCell>
            );
        }

        const value = getValue();

        return (
            <ViewTableCell>
                <span>
                    {value
                        ? format(parseISO(value), SCHEDULE_DATE_FORMAT)
                        : "-"}
                </span>
            </ViewTableCell>
        );
    },
);

ServiceTemplateScheduleNextOccurrenceDateCell.displayName =
    "ServiceTemplateScheduleNextOccurrenceDateCell";
